const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORAGE_KEY = 'vox_utm';

/**
 * Capture utm_* query params into sessionStorage (first touch wins for the
 * session). Called on app load and on the /try-free ad-landing page so
 * attribution survives in-app navigation before signup/checkout.
 */
export const captureUtmParams = () => {
  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return; // first touch wins
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) utm[k] = v.slice(0, 100);
    });
    if (Object.keys(utm).length > 0) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
    }
  } catch (e) { /* storage unavailable — attribution is best-effort */ }
};

/** Returns the captured utm object, or null when the visit was untracked. */
export const getStoredUtm = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};
